const FAQDataAr = [
    {
        faqCat: "FAQ",
        faqData: [

            {
                questionId: 1,
                question: "من هي شركة مسار التميز لتقنية المعلومات؟",
                answer: "شركة مسار التميز هي وكالة تسويق رقمي سعودية تقدّم حلولًا إعلانية متكاملة تشمل التسويق الإلكتروني، السوشيال ميديا، تحسين محركات البحث (SEO)، البرمجة، المطبوعات، الكتب، الفلايرات، والهدايا. تهدف الشركة إلى مساعدة العلامات التجارية على بناء حضور قوي رقميًا وميدانيًا من خلال خدمات تجمع بين الإبداع، التقنية، والخبرة التسويقية."
            },
            {
                questionId: 2,
                question: "ما هي الخدمات التي تقدمها شركة مسار التميز؟",
                answer: (
                    <div>
                        <p>
                            تقدّم شركة مسار التميز مجموعة شاملة من خدمات التسويق الرقمي لدعم نمو العلامات
                            التجارية في السعودية والخليج. تشمل خدماتنا:
                        </p>
                        <ul>
                            <li>التسويق الإلكتروني عبر منصات متعددة</li>
                            <li>إدارة حسابات التواصل الاجتماعي</li>
                            <li>تحسين محركات البحث (SEO)</li>
                            <li>تصميم وتطوير المواقع الإلكترونية</li>
                            <li>خدمات الطباعة والتصميم</li>
                            <li>إنتاج المحتوى الرقمي والإعلامي</li>
                        </ul>
                        <p>
                            نهدف إلى تقديم حلول مخصصة تلبي احتياجات عملائنا وتساعدهم على تحقيق أهدافهم التسويقية.
                        </p>
                    </div>
                )
            },
            {
                questionId: 3,
                question: "كم تكلفة إدارة حسابات التواصل الاجتماعي؟",
                answer: (
                    <div>
                        <p>تختلف التكلفة حسب عدد المنصات، نوع المحتوى، وحجم النشاط التجاري.<br />
                            توفر شركة مسار التميز باقات مرنة تشمل إنشاء المحتوى، الجدولة، والتقارير الشهرية
                            لقياس الأداء.
                            <br />
                            اطلب عرض سعر مخصص الآن.</p>
                    </div>
                )
            },
            {
                questionId: 4,
                question: "هل تقدمون خططًا مرنة تناسب المشاريع الصغيرة والمتوسطة؟",
                answer: "نعم، نوفر خططًا مرنة تشمل إدارة الحسابات، الحملات الإعلانية، إنشاء المحتوى، وتحسين محركات البحث (SEO)، مع إمكانية تخصيص كل خطة بحسب أهداف العميل وميزانيته"
            },
            {
                questionId: 5,
                question: "كيف تتم عملية التخطيط للحملات الإعلانية من الفكرة إلى التنفيذ؟",
                answer: (<div>
                    <p>تمر الحملات بعدة مراحل:</p>
                    <ol className="list-decimal">
                        <li>تحليل السوق والمنافسين في نفس المجال.</li>
                        <li>دراسة الجمهور المستهدف.</li>
                        <li>وضع الاستراتيجية واختيار المنصات المناسبة.</li>
                        <li>إنشاء المحتوى الإعلاني الجذّاب وإطلاق الحملة.</li>
                        <li>متابعة الأداء وتحسين النتائج لتحقيق أعلى ROI.</li>
                    </ol>
                </div>
                )
            },
            {
                questionId: 6,
                question: "هل تتولّون إنشاء المحتوى بالكامل (نصوص، صور، فيديوهات) أم جزء منه فقط؟",
                answer: "نعم، ننتج المحتوى بالكامل من نصوص، صور، وفيديوهات، مع إمكانية تنفيذ حملات متكاملة تشمل الإعلانات الممولة وإدارة الحسابات."
            },
            {
                questionId: 7,
                question: "ما هي منصات التواصل الاجتماعي التي تغطّيها شركة مسار التميز؟",
                answer: "إنستغرام، سناب شات، تيك توك، تويتر(X)، فيسبوك، ولينكدإن. مع إدارة متكاملة تشمل إنشاء المحتوى، النشر المنتظم، التفاعل مع المتابعين، وتحليل الأداء لضمان أفضل النتائج التسويقية."
            },
            {
                questionId: 8,
                question: "هل الخدمة تشمل الإعلانات الممولة أم النشر العضوي فقط؟",
                answer: "تشمل خدمات شركة مسار التميز الإعلانات الممولة والنشر العضوي معًا، ويتم تحديد النسبة بينهما وفق الميزانية المتاحة وأهداف العميل لتحقيق أفضل النتائج."
            },
            {
                questionId: 9,
                question: "كيف تضمنون توافق المحتوى مع الثقافة والقيم السعودية؟",
                answer: "نقوم بـ دراسة الجمهور المستهدف وتخصيص الخطط طبقًا لكل شريحة، ثم نراجع المحتوى قبل النشر لضمان ملاءمته الثقافية"
            },
            {
                questionId: 10,
                question: "هل لديكم أمثلة أو دراسات حالة من عملاء سابقين؟",
                answer: (<p>نعم، تمتلك شركة مسار التميز مجموعة من الأمثلة ودراسات الحالة من مشاريع ناجحة في مجالات مختلفة.<b />
                    وعند الطلب، يتم مشاركة أمثلة أو دراسات مناسبة لمجال العميل لإظهار النتائج والخبرة في نفس القطاع.
                </p>)
            },
            {
                questionId: 11,
                question: "هل توجد لغة إنجليزية أو محتوى ثنائي اللغة كجزء من الخدمات؟",
                answer: "نوفر خدمات المحتوى الثنائي اللغة (عربي وإنجليزي) بما في ذلك كتابة النصوص، تصميم المنشورات، وإدارة الحملات"
            },
            {
                questionId: 12,
                question: "متى يمكنني رؤية النتائج من حملات التسويق الرقمي؟",
                answer: (<p>تظهر نتائج التفاعل خلال الأسابيع الأولى من إطلاق الحملات، بينما تحقيق النتائج الملموسة وعائد الاستثمار (ROI) غالبًا يحتاج من شهرين إلى ثلاثة أشهر، مع تقارير دورية لمتابعة الأداء <b />
                    كما يتم تحديد الأهداف في الخطة ومتابعة تحقيقها بشكل مستمر لضمان أفضل النتائج.</p>)
            },
            {
                questionId: 13,
                question: "كيف يتم التواصل والتنسيق مع العملاء؟",
                answer: "نوفر تواصلًا مباشرًا وفعّالًا مع العملاء عبر اجتماعات دورية، تقارير شهرية، ورسائل فورية لضمان تنفيذ الحملات بدقة وتحقيق أهداف العلامة التجارية."
            },
            {
                questionId: 14,
                question: "ما هي باقات التسويق الإلكتروني التي تقدمها شركة مسار التميز؟",
                answer: "نوفر باقات مرنة مصممة لتحقيق أهداف العلامة التجارية مثل زيادة التفاعل، الوصول إلى الجمهور المستهدف، وتعزيز الحضور الرقمي، مع إمكانية تخصيص كل باقة بحسب أهداف العميل واستراتيجيته الرقمية."
            },
            {
                questionId: 15,
                question: "كيف أختار وكالة تسويق رقمي مناسبة في الرياض أو السعودية؟",
                answer: (<div>
                    <p>لاختيار وكالة تسويق رقمي مناسبة، يُنصح بمراجعة عدة عوامل:</p>
                    <ul className="list-disc">
                        <li>نوع الخدمات والخبرة لضمان توافقها مع أهدافك التسويقية.</li>
                        <li>سجل النجاحات ودراسات الحالة للتأكد من كفاءة الوكالة في تحقيق النتائج.</li>
                        <li>مرونة الباقات والتقارير الدورية لمتابعة الأداء والتحسين المستمر.</li>
                        <li>توافق المحتوى مع الثقافة والقيم المحلية لضمان نجاح الحملات في السوق السعودي.</li>
                    </ul>
                    <p className="fw-bold">شركة مسار التميز لتقنية المعلومات توفر كل هذه المعايير مع خدمات متكاملة لدعم نمو الأعمال.
                    </p>
                </div>
                )
            }
        ]
    },
    {
        faqCat: "FAQ_Print",
        faqData: [

            {
                questionId: 1,
                question: "ما أنواع الطباعة التي تقدمها مسار التميز؟",
                answer: "نقدّم جميع أنواع الطباعة التجارية والاحترافية، تشمل الطباعة الأوفست للكتب والمجلات، والطباعة الرقمية للكميات الصغيرة، بالإضافة إلى خدمات التعبئة والتغليف بأعلى جودة إنتاجية."
            },
            {
                questionId: 2,
                question: "هل يمكن تنفيذ التصميم والطباعة في نفس الوقت؟",
                answer: "نعم، يتولى فريق التصميم الداخلي إعداد الملفات الجاهزة للطباعة وفقًا للمواصفات الفنية المعتمدة، مما يضمن دقة الألوان والمقاسات وسرعة التنفيذ دون الحاجة لجهات خارجية."
            },
            {
                questionId: 3,
                question: "كم المدة اللازمة لاستلام الطلب؟",
                answer: "تختلف حسب نوع المشروع، لكنها عادة تتراوح بين 3  إلى 7 أيام عمل بعد اعتماد التصميم النهائي، مع إمكانية التنفيذ العاجل للمشاريع الطارئة."
            },
        ]
    },
    {
        faqCat: "FAQ_Books",
        faqData: [

            {
                questionId: 1,
                question: "هل يمكن لمؤلف مستقل نشر كتابه من خلالكم؟",
                answer: "بالتأكيد، نوفر حلولًا متكاملة للمؤلفين تبدأ من التصميم والمراجعة وحتى الطباعة والتوزيع المحلي والدولي عبر المنصات الإلكترونية والمكتبات."
            },
            {
                questionId: 2,
                question: "هل تقوم مسار  ISBN ورقم الإيداع للكتاب؟",
                answer: "نعم، نقدم خدمة إصدار رقم الإيداع ورقم ISBN بالتعاون مع وزارة الإعلام السعودية لضمان توثيق حقوق النشر رسميًا"
            },
            {
                questionId: 3,
                question: "هل يمكنكم تسويق وتوزيع الكتاب بعد الطباعة؟",
                answer: "نعم، نقدم خطط تسويق ونشر رقمية وميدانية تشمل المتاجر الإلكترونية، ومعارض الكتب، والحملات الإعلانية المدفوعة"
            },
        ]
    },
    {
        faqCat: "FAQ_Web",
        faqData: [

            {
                questionId: 1,
                question: "ما نوع المواقع التي تطورها مسار التميز؟",
                answer: "نطور جميع أنواع المواقع التعريفية، التجارية، التعليمية، والمتاجر الإلكترونية باستخدام برمجة احترافية متوافقة مع جميع الأجهزة ومحركات البحث."
            },
            {
                questionId: 2,
                question: "هل يشمل العمل الاستضافة والدومين والدعم الفني؟",
                answer: "نعم، نقدم باقات متكاملة تشمل حجز النطاق، استضافة آمنة، وتحديثات وصيانة فنية مستمرة لضمان الأداء والاستقرار"
            },
            {
                questionId: 3,
                question: "كم يستغرق تنفيذ الموقع؟",
                answer: "يتراوح التنفيذ عادة بين3 إلى 6 أسابيع حسب حجم المحتوى والخصائص المطلوبة، مع تسليم مراحل جزئية للمراجعة والاعتماد أولًا بأول."
            },
        ]
    },
    {
        faqCat: "FAQ_Systems",
        faqData: [

            {
                questionId: 1,
                question: "ما نوع الأنظمة التي يمكن تطويرها؟",
                answer: "نقوم بتطوير أنظمة إدارة المؤسسات، تطبيقات الجوال، المتاجر الإلكترونية، وأنظمة الحجز والدفع باستخدام أحدث تقنيات البرمجة"
            },
            {
                questionId: 2,
                question: "هل توفرون دعمًا وصيانة بعد التسليم؟",
                answer: "نعم، نقدم دعمًا فنيًا مجانيًا خلال فترة الضمان، مع إمكانية التعاقد على صيانة سنوية تشمل التحديثات الأمنية والتطوير المستمر"
            },
            {
                questionId: 3,
                question: "كيف يتم تحديد تكلفة المشروع البرمجي؟",
                answer: "يتم التسعير بناءً على تحليل دقيق لاحتياجات العميل وعدد الخصائص والمراحل المطلوبة، ويتم تقديم عرض فني ومالي تفصيلي قبل بدء التنفيذ."
            },
            {
                questionId: 4,
                question: "ما هى طرق التواصل مع شركة مسار التميز لتقنية المعلومات؟",
                answer: (<div>
                    <p>
                        فريق مسار التميز جاهز دائمًا لمساعدتك في اختيار الخدمة الأنسب لأهدافك التسويقية.
                        سواء كنت تبحث عن إدارة حسابات التواصل الاجتماعي، تصميم موقع إلكتروني، أو خدمات
                        الطباعة والنشر يمكنك التواصل معنا بالطريقة التي تفضّلها:
                    </p>

                    <ul className="list-disc">
                        <li>عبر واتساب للاستفسارات والرد السريع.</li>
                        <li>عبر البريد الإلكتروني لطلبات العروض أو التعاونات التجارية.</li>
                        <li>
                            من خلال نموذج الاتصال في موقعنا لاختيار الخدمة المطلوبة وإرسال التفاصيل مباشرة.
                        </li>
                    </ul>
                    <p>
                        يسعدنا تواصلك معنا في أي وقت، وسنحرص على الرد بسرعة وتقديم الحل الأنسب لاحتياجاتك.
                    </p>
                </div>
                )
            },
        ]
    },
];

export default FAQDataAr;